import React, { useEffect } from 'react';
import './Notifications.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

/*
 Robust global notification system using a single window event.
 Prevents duplicate listener registrations across HMR
 and dedupes toasts using toastId.
*/

const GLOBAL_EVENT_NAME = 'global-toast-event';
const DEFAULT_TOAST_ID = 'GLOBAL_NOTIFICATION';

// Broadcast function
export const broadcastNotification = (data = {}) => {
    if (typeof window === 'undefined') return;
    window.dispatchEvent(new CustomEvent(GLOBAL_EVENT_NAME, { detail: data }));
};


const Notifications = () => {
    useEffect(() => {
        if (typeof window === 'undefined') return;

        // Ensure handler is registered only once
        if (window.__globalToastHandlerRegistered) return;

        const handler = (event) => {
            const data = event?.detail || {};

            const toastId = data.toastId || DEFAULT_TOAST_ID;

            // Prevent duplicate toasts
            if (toast.isActive(toastId)) return;

            const showToast = toast[data.type] || toast.info;

            showToast(
                <div className="custom-toast-content">
                    <span
                        className={`toast-icon toast-icon-${data.type || 'info'}`}
                    />
                    <div className="toast-text">
                        <div className="toast-title">{data.title}</div>
                        <div className="toast-desc">{data.description}</div>
                    </div>
                </div>,
                {
                    position: 'top-center',
                    toastId,
                    className: `glass-toast toast-${data.type || 'info'}`,
                    bodyClassName: 'glass-toast-body',
                }
            );
        };

        window.addEventListener(GLOBAL_EVENT_NAME, handler);
        window.__globalToastHandlerRegistered = true;

        return () => {
            window.removeEventListener(GLOBAL_EVENT_NAME, handler);
            window.__globalToastHandlerRegistered = false;
        };
    }, []);

    const testNotification = {
        title: 'Low Stock Alert',
        description: 'Product stock is running low',
        type: 'warning',
        // toastId: 'LOW_STOCK_1'
    };

    return (
        <div className="notifications-page">
            <ToastContainer
                position="top-center"
                autoClose={3000}
                newestOnTop
                closeOnClick
                pauseOnHover
                draggable
                limit={1}
                theme="light"
                progressClassName="glass-toast-progress"
            />

            <button
                className="action-btn test"
                onClick={() => broadcastNotification(testNotification)}
            >
                🔔 Test Notification
            </button>
        </div>
    );
};

export default Notifications;
